import React from 'react';
import Tooltip from 'design-system/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const SlackChannelActionsRemoveChannel = (props: $FIXME) => {
  return (
    <>
      <div className={`current-channel-container`}>
        <Tooltip title="Edit Channel" placement="top" arrow>
          <div className="edit-button" onClick={() => props.onEdit?.(props.channel)}>
            <FontAwesomeIcon icon="edit" style={{ color: '#9CA3AF', fontSize: '20px' }} />
          </div>
        </Tooltip>
        <Tooltip title="Undo Remove" placement="top" arrow>
          <div
            className={`undo-remove-button ${props.isLoading ? 'disabled' : ''}`}
            onClick={() => props.onCancelRemove?.(props.channel)}
          >
            <FontAwesomeIcon icon="trash-undo" style={{ color: '#9CA3AF', fontSize: '20px' }} />
          </div>
        </Tooltip>
      </div>
      <style jsx>{`
        .current-channel-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 4px;
        }

        .edit-button {
          cursor: pointer;
          width: 20px;
          height: 20px;
        }

        .undo-remove-button {
          cursor: pointer;
          width: 20px;
          height: 20px;
        }
      `}</style>
    </>
  );
};

export default SlackChannelActionsRemoveChannel;
